import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import { Divider, Paper } from "@material-ui/core";
import Container from "@material-ui/core/Container";
import main from "../assets/images/main.png";
import nhsst from "../assets/images/nhsst.png";
import aops from "../assets/images/aops.png";
import wolfram from "../assets/images/wolfram.png";
import maplesoft from "../assets/images/maplesoft.jpeg";
import mainbg from "../assets/images/mainbg.jpg";
import discord from "../assets/images/discord.png";
import buzzer from "../assets/images/buzzer.png";
import inter from "../assets/images/inter.png";
import sectionbg from "../assets/images/section-bg.jpg";
import Button from "@material-ui/core/Button";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    width: "100%",
  },
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  content: {
    flexGrow: 1,
    overflow: "auto",
  },
  paper: {
    padding: theme.spacing(3),
    height: "100%",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  element: {
    padding: theme.spacing(2),
    textAlign: "left",
    height: "100%",
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  icon: { objectFit: "contain", maxHeight: "150px", marginBottom: "20px" },
  fixedHeight: {
    height: 240,
  },
  flex: {
    display: "flex",
    flexGrow: 1,
    flexDirection: "column",
  },
  backgroundSection: {
    backgroundImage: sectionbg,
  },
  fullWidth: {
    width: "100vw",
    position: "absolute",
    left: "50%",
    right: "50%",
    marginTop: "-10px",
    marginLeft: "-50vw",
    marginRight: "-50vw",
    height: "100%",
    zIndex: 0,
    backgroundImage: `url(${mainbg})`,
    backgroundSize: "100% auto",
    backgroundColor: "#000",
  },
}));

export default function Home() {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3} justifyContent="center">
        <Grid
          container
          spacing={3}
          style={{ position: "relative" }}
          justifyContent="center"
        >
          <div className={classes.fullWidth}></div>
          <Grid
            container
            spacing={3}
            justifyContent="center"
            style={{ zIndex: 1, padding: "20px" }}
          >
            <Grid item lg={6} xs={12}>
              <img
                alt=""
                style={{
                  objectFit: "contain",
                  width: "100%",
                  maxHeight: "350px",
                }}
                src={main}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <div className={classes.element} style={{ color: "#fff" }}>
                <div className={classes.flex} />
                <Typography variant="h3" component="h2">
                  <b>Powering scientific minds.</b>
                </Typography>
                <Typography variant="h6" component="h2">
                  The American Science Tournaments Association helps students of
                  all skill levels compete in fast-paced science competitions.
                </Typography>
                <Divider style={{ background: "#fff", margin: "20px 0" }} />
                <Typography variant="subtitle2" component="h2">
                  Registration for the 2021 National High School Science
                  Tournament is now open! Register using the ASTA portal by
                  August 1 (Spots will be given on a first-come-first-serve
                  basis).
                </Typography>
                <Button
                  style={{ width: "fit-content", marginTop: "10px" }}
                  variant="outlined"
                  color="secondary"
                  component="a"
                  href="https://portal--asta-tournaments.netlify.app"
                  target="_blank"
                >
                  ASTA PORTAL
                </Button>
                <div className={classes.flex} />
              </div>
            </Grid>
          </Grid>
        </Grid>
        <Grid item md={4} xs={12}>
          <Paper className={classes.paper}>
            <img alt="" src={buzzer} className={classes.icon} />
            <Typography variant="h4" component="h2">
              <b>Buzzer-based</b>
            </Typography>
            <Typography variant="subtitle1">
              Contestants compete to answer questions the fastest based on clues
              of decreasing difficulty, rewarding students with deep knowledge
              and quick reflexes.
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={4} xs={12}>
          <Paper className={classes.paper}>
            <img alt="" src={discord} className={classes.icon} />
            <Typography variant="h4" component="h2">
              <b>Online</b>
            </Typography>
            <Typography variant="subtitle1">
              ASTA tournaments are held over Discord with live statistics and
              scoring, allowing teams from across the country to compete with
              little logistical hassle.
            </Typography>
          </Paper>
        </Grid>
        <Grid item md={4} xs={12}>
          <Paper className={classes.paper}>
            <img alt="" src={inter} className={classes.icon} />
            <Typography variant="h4" component="h2">
              <b>Interdisciplinary</b>
            </Typography>
            <Typography variant="subtitle1">
              Our theoretical and computational questions cover concepts from
              physics, math, chemistry, biology, astronomy, earth science,
              computer science, and more.
            </Typography>
          </Paper>
        </Grid>
        <Grid item xs={12} style={{ height: "50px" }} />
        <Grid item lg={6} xs={12}>
          <div
            className={classes.element}
            style={{ alignItems: "center", textAlign: "center" }}
          >
            <div className={classes.flex} />
            <Typography variant="h3" component="h2">
              <b>NHSST 2021</b>
            </Typography>
            <Typography variant="h6" component="h2">
              ASTA will be hosting its first tournament on August 8, 2021 from 8:30 AM to 5:30 PM PDT.
            </Typography>
            <Button
              style={{ width: "fit-content", marginTop: "10px" }}
              variant="outlined"
              color="secondary"
              component={Link}
              to="/about"
            >
              Learn more
            </Button>
            <div className={classes.flex} />
          </div>
        </Grid>
        <Grid item lg={6} xs={12}>
          <img
            alt=""
            style={{ objectFit: "contain", width: "100%", maxHeight: "350px" }}
            src={nhsst}
          />
        </Grid>
        <Grid item xs={12}>
          <Divider />
        </Grid>
        <Grid item lg={12} xs={12}>
          <Typography variant="h3" component="h2">
            <b>Our Sponsors</b>
          </Typography>
        </Grid>
        <Grid item lg={6} xs={12}>
          <a href="https://www.wolfram.com/">
            <img
              alt=""
              style={{
                objectFit: "contain",
                width: "100%",
                maxHeight: "150px",
              }}
              src={wolfram}
            />
          </a>
        </Grid>
        <Grid item lg={6} xs={12}>
          <a href="https://artofproblemsolving.com/">
            <img
              alt=""
              style={{
                objectFit: "contain",
                width: "100%",
                maxHeight: "150px",
              }}
              src={aops}
            />
          </a>
        </Grid>
        <Grid item lg={6} xs={12}>
          <a href="https://www.maplesoft.com/">
            <img
              alt=""
              style={{
                objectFit: "contain",
                width: "100%",
                maxHeight: "200px",
              }}
              src={maplesoft}
            />
          </a>
        </Grid>
        <Grid item xs={12} style={{ height: "20px" }} />
      </Grid>
    </Container>
  );
}
